import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8b0ea600")

_pushScopeId("data-v-8b0ea600")
const _hoisted_1 = {
  novalidate: "",
  id: "providerNotificationsRestrictionsForm"
}
const _hoisted_2 = {
  class: "accordion",
  id: "accordionProviderNotifications"
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = {
  class: "default-card-header white-card-header collapsed",
  id: "headingBasicNotification",
  "data-toggle": "collapse",
  "data-target": "#providerUnfinishedProductsNotification"
}
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "providerUnfinishedProductsNotification"
}
const _hoisted_7 = { class: "status-title" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "status-green"
}
const _hoisted_10 = {
  key: 1,
  class: "status-red"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "arrow gray float-right" }, null, -1)
const _hoisted_12 = {
  id: "providerUnfinishedProductsNotification",
  class: "collapse",
  "aria-labelledby": "headingBasicNotification",
  "data-parent": "#accordionProviderNotifications"
}
const _hoisted_13 = { class: "card-body default-card-body" }
const _hoisted_14 = { class: "several-section" }
const _hoisted_15 = { class: "sub-notification-block" }
const _hoisted_16 = { class: "status-title" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "status-green"
}
const _hoisted_19 = {
  key: 1,
  class: "status-red"
}
const _hoisted_20 = { class: "sub-notification-block" }
const _hoisted_21 = { class: "status-title" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  class: "status-green"
}
const _hoisted_24 = {
  key: 1,
  class: "status-red"
}
const _hoisted_25 = { class: "sub-notification-block" }
const _hoisted_26 = { class: "status-title" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 0,
  class: "status-green"
}
const _hoisted_29 = {
  key: 1,
  class: "status-red"
}
const _hoisted_30 = { class: "sub-notification-block" }
const _hoisted_31 = { class: "status-title" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 0,
  class: "status-green"
}
const _hoisted_34 = {
  key: 1,
  class: "status-red"
}
const _hoisted_35 = { class: "sub-notification-block" }
const _hoisted_36 = { class: "status-title" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 0,
  class: "status-green"
}
const _hoisted_39 = {
  key: 1,
  class: "status-red"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("form", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h5", _hoisted_5, [
            _createVNode("button", _hoisted_6, _toDisplayString(_ctx.$t('provider.notifications-restrictions.unfinished-products-notifications-group-title')), 1)
          ]),
          _createVNode("div", _hoisted_7, [
            (_ctx.editMode === false)
              ? (_openBlock(), _createBlock("h5", _hoisted_8, [
                  (_ctx.unfinishedProductsNotificationsToggle)
                    ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('label.active')), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('label.notactive')), 1))
                ]))
              : _withDirectives((_openBlock(), _createBlock("input", {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.activateDeactivateUnfinishedGroupNotifications(!_ctx.unfinishedProductsNotificationsToggle)), ["stop"])),
                  type: "checkbox",
                  class: "toggle",
                  checked: _ctx.unfinishedProductsNotificationsToggle,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.unfinishedProductsNotificationsToggle = $event))
                }, null, 8, ["checked"])), [
                  [_vModelCheckbox, _ctx.unfinishedProductsNotificationsToggle]
                ])
          ]),
          _hoisted_11
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.unfinished-products-notifications.product-no-slots')), 1),
                _createVNode("div", _hoisted_16, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_17, [
                        (_ctx.notificationsRestrictions.unfinishedProductSlotEmpty)
                          ? (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.unfinishedProductSlotEmpty,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.notificationsRestrictions.unfinishedProductSlotEmpty = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.unfinishedProductSlotEmpty]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.unfinished-products-notifications.product-no-prices')), 1),
                _createVNode("div", _hoisted_21, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_22, [
                        (_ctx.notificationsRestrictions.unfinishedProductPriceEmpty)
                          ? (_openBlock(), _createBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.unfinishedProductPriceEmpty,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.notificationsRestrictions.unfinishedProductPriceEmpty = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.unfinishedProductPriceEmpty]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_25, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.unfinished-products-notifications.product-slots-less-30')), 1),
                _createVNode("div", _hoisted_26, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_27, [
                        (_ctx.notificationsRestrictions.unfinishedProductSlotLess)
                          ? (_openBlock(), _createBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.unfinishedProductSlotLess,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.notificationsRestrictions.unfinishedProductSlotLess = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.unfinishedProductSlotLess]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_30, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.unfinished-products-notifications.product-prices-less-30')), 1),
                _createVNode("div", _hoisted_31, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_32, [
                        (_ctx.notificationsRestrictions.unfinishedProductPriceLess)
                          ? (_openBlock(), _createBlock("span", _hoisted_33, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_34, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.unfinishedProductPriceLess,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.notificationsRestrictions.unfinishedProductPriceLess = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.unfinishedProductPriceLess]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_35, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('notifications-restrictions.unfinished-products-notifications.product-no-photos')), 1),
                _createVNode("div", _hoisted_36, [
                  (_ctx.editMode === false)
                    ? (_openBlock(), _createBlock("h5", _hoisted_37, [
                        (_ctx.notificationsRestrictions.unfinishedProductNoPhoto)
                          ? (_openBlock(), _createBlock("span", _hoisted_38, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_39, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.activateDeactivateNotificationRestrictions())),
                        type: "checkbox",
                        class: "toggle",
                        checked: _ctx.notificationsRestrictions.unfinishedProductNoPhoto,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.notificationsRestrictions.unfinishedProductNoPhoto = $event))
                      }, null, 8, ["checked"])), [
                        [_vModelCheckbox, _ctx.notificationsRestrictions.unfinishedProductNoPhoto]
                      ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
})